<template>
  <slot name="icon" />
  <div v-if="isModal" class="tw-flex tw-flex-row tw-items-center">
    <div
      :class="[
        'tw-text-[#B7B7B7] tw-text-[11px] tw-p-[6px] tw-pl-[9px]  assessment-tag ' +
          (!isFocus && !value && !isHover ? 'is-out-focus-input' : ''),
      ]"
    >
      <span>{{
        getUiText("app-component-assessments-search-box-assessment-tag-2")
      }}</span>
    </div>
    <div
      v-if="activeCategoryName"
      :class="[
        'tw-flex-initial tw-items-center tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-text-[#387DFF] tw-bg-[#F2F8FF] tw-font-medium tw-rounded-[6px] assessment-tag ' +
          (!isFocus && !value && !isHover ? 'is-out-focus-input' : ''),
      ]"
    >
      <p class="tw-m-0">
        {{
          activeCategoryName
            ? activeCategoryName
            : getUiText("app-component-assessments-search-box-assessment-tag-1")
        }}
      </p>
    </div>
    <div
      v-else
      class="custom-global-skeleton tw-bg-[#ffffff] tw-min-w-[60px] tw-h-[20px] tw-w-[100%]"
    ></div>
  </div>
  <div class="tw-flex-1">
    <input
      :id="id"
      ref="searchInput"
      :value="value"
      :data-cy="dataCy"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :class="`tw-flex tw-w-full tw-items-start ${classStyle} ${
        hasError ? 'tw-border-red-500 tw-text-[red]' : ''
      }`"
      @input="updateValueInput"
      @blur="onBlur"
      @focus="onFocus"
      @keypress="onEnter"
    />
  </div>
</template>

<script lang="ts">
import { Ref, ref } from "vue";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import utilities from "@/utils/utilities";
import store from "@/store";

@Component({
  components: {},
  emits: [
    "on:focus-search",
    "on:outFocusSearch",
    "on:enter",
    "on:blur",
    "update:value",
    "update",
  ],
})
export default class InputField1 extends Vue {
  @Prop({ required: true }) readonly type: string = "";
  @Prop({ required: true, default: "" }) readonly classStyle: string | Ref =
    ref("");
  @Prop({ required: false, default: "" }) readonly placeholder: string = "";
  @Prop({ required: false, default: "" }) readonly dataCy: string = "";
  @Prop({ required: false, default: "" }) readonly id: string = "";
  @Prop({ required: false, default: "" }) readonly name: string = "";
  @Prop({ required: false, default: false }) readonly required: boolean = false;
  @Prop({ required: false }) value: string | Ref = ref("");
  @Prop({ required: false, default: false }) readonly hasError: boolean = false;
  @Prop({ required: false, default: false }) readonly isHover: boolean = false;
  @Prop({ required: false, default: false }) readonly isModal: boolean = false;
  @Prop({ required: false }) activeCategoryName: string | Ref = ref("");
  @Prop({ required: false, default: false }) readonly debounce: number = 0;
  @Prop({ required: false, default: false }) isAutoFocus = false;
  timeoutId: any | number | null = null;
  isFocus = false;
  updateValueInput(e) {
    if (this.debounce === 0) {
      this.$emit("update:value", e.target.value);
      return;
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.$emit("update:value", e.target.value);
    }, this.debounce);
  }

  getUiText(id: string, isArray = false) {
    return utilities.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }

  onFocus() {
    this.isFocus = true;
    this.$emit("on:focusSearch");
  }

  onFocusOut() {
    this.isFocus = false;
    this.$emit("on:outFocusSearch");
  }

  onEnter(e) {
    if (e.key === "Enter") {
      this.$emit("on:enter");
    }
  }

  onBlur() {
    this.isFocus = false;
    this.$emit("on:blur");
  }

  @Watch("isAutoFocus")
  onFocusChange() {
    if (this.isAutoFocus) {
      (this.$refs.searchInput as any).focus();
      this.onFocus();
    }
  }
}
</script>

<style scoped lang="scss">
input {
  font-family: "Poppins";
  &:hover,
      // &:focus
      &:active,
      &:focus:focus {
    color: #231f20;
    font-size: 13px;
    background-color: #eff0f180;
    border: 1px solid #eff0f1;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}

input.background-gray {
  background: rgba(239, 240, 241, 0.5);
}

input::placeholder {
  color: #b7b7b7;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.input-invalid-style-1 {
  border-color: #f7553c;
  background-color: #fee5e2;
}

.search-box-assessment input {
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.search-box-assessment input::placeholder {
  color: #b7b7b7;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.assessment-tag {
  transition-property: max-width, display;
  transition-timing-function: ease-in-out;
  transition-duration: 1s;
  max-width: 1000px;
}
.assessment-tag p {
  transition-property: font-size, line-height, width;
  transition-timing-function: ease-in-out;
  transition-duration: 0.75s;
  font-size: 11px;
  line-height: 16.5px;
  width: 100%;
}
.is-out-focus-input {
  max-width: 0;
  padding: 0;
  display: none;
}
.is-out-focus-input p {
  font-size: 0;
  line-height: 0;
  width: 0;
}
</style>
